import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-quick-info',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div
      class="surface-card rounded-3xl p-5 md:p-6 antialiased"
    >
      <div class="flex items-center gap-2 mb-5 pb-2 border-b border-border-subtle">
        <div class="w-1.5 h-3.5 bg-primary rounded-sm shadow-sm"></div>
        <h3 class="text-xs font-black text-text-primary uppercase tracking-wider font-mono">
          {{ 'projectsDetails.quickMetrics' | translate }}
        </h3>
      </div>

      <div class="space-y-4">
        <div class="flex items-center justify-between pb-3.5 border-b border-border-subtle">
          <div class="flex items-center gap-2.5 text-text-secondary">
            <div
              class="w-6 h-6 rounded-lg bg-surface-elevated border border-border flex items-center justify-center text-text-muted"
            >
              <i class="fa-regular fa-calendar-check text-[10px]"></i>
            </div>
            <span class="text-xs font-semibold tracking-tight">{{ 'projectsDetails.deliveryDate' | translate }}</span>
          </div>
          <span
            class="text-xs font-mono font-bold text-text-primary bg-surface-elevated px-2 py-0.5 rounded-md border border-border"
          >
            {{ deliveryDate }}
          </span>
        </div>

        <div class="flex items-center justify-between pb-3.5 border-b border-border-subtle">
          <div class="flex items-center gap-2.5 text-text-secondary">
            <div
              class="w-6 h-6 rounded-lg bg-surface-elevated border border-border flex items-center justify-center text-text-muted"
            >
              <i class="fa-solid fa-cubes text-[10px]"></i>
            </div>
            <span class="text-xs font-semibold tracking-tight">{{ 'projectsDetails.totalUnits' | translate }}</span>
          </div>
          <span class="text-xs font-mono font-bold text-text-primary">
            {{ totalUnits }}
          </span>
        </div>

        <div class="flex items-center justify-between pt-0.5">
          <div class="flex items-center gap-2.5 text-text-secondary">
            <div
              class="w-6 h-6 rounded-lg bg-primary-soft flex items-center justify-center text-primary"
            >
              <i class="fa-solid fa-fire text-[10px]"></i>
            </div>
            <span class="text-xs font-semibold tracking-tight">{{ 'projectsDetails.availableInventory' | translate }}</span>
          </div>

          <div
            class="px-2.5 py-1 bg-primary-soft border border-primary/20 rounded-xl flex items-center gap-1.5"
          >
            <div class="w-1.5 h-1.5 rounded-full bg-primary"></div>
            <span class="text-[11px] font-mono font-black text-primary uppercase tracking-wide">
              {{ availableUnits }}
            </span>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class QuickInfoComponent {
  @Input() deliveryDate: string = '';
  @Input() totalUnits: string = '';
  @Input() availableUnits: string = '';
}
